import { useState, useEffect } from "react";
import { Base_URL } from "../actions/API_endpoint";

const useLinks = () => {
    const [links, setLinks] = useState({
        mpdi_apply_link: "#",
        pdi_apply_link: "#",
        book_your_slot_link: "#",
        social_twitter: "#",
        social_linkedin: "#",
        social_instagram: "#",
        social_facebook: "#",
        social_youtube: "#"
    });

    useEffect(() => {
        const fetchLinks = async () => {
            try {
                const response = await fetch(`${Base_URL}/api/links`);
                const data = await response.json();

                if (data.success && data.data) {
                    const linksMap = {};
                    data.data.forEach(link => {
                        linksMap[link.key] = link.url;
                    });
                    setLinks(prev => ({ ...prev, ...linksMap }));
                }
            } catch (error) {
                console.error("Error fetching links:", error);
            }
        };

        fetchLinks();
    }, []);

    return links;
};

export default useLinks;
